import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiStar, FiGlobe, FiShield } from 'react-icons/fi';
import { motion } from 'framer-motion';

const Home = () => {
  return (
    <div className="min-h-screen relative overflow-hidden galaxy-bg">
      {/* Hero Section */}
      <div className="relative pt-32 pb-20 sm:pt-40 sm:pb-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="inline-block px-4 py-1.5 mb-6 rounded-full bg-blue-500/10 border border-blue-500/20">
              <span className="text-xs font-bold text-blue-400 uppercase tracking-widest">Powered by Maysalward</span>
            </div>
            <h1 className="text-4xl sm:text-7xl font-black tracking-tight mb-8">
              <span className="block text-white">The Capsule Impact</span>
              <span className="block bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-500">
                Universe
              </span>
            </h1>
            <p className="mt-4 max-w-2xl mx-auto text-xl text-slate-400 mb-10 leading-relaxed">
              Join the Maysalward ecosystem where every verified contribution fuels the Capsule. Build your constellation, grow your orbit, and light up the shared universe.
            </p>
            <div className="flex justify-center gap-4">
              <Link
                to="/galaxy"
                className="px-8 py-4 rounded-full bg-slate-800 text-white font-bold hover:bg-slate-700 transition-all border border-slate-700"
              >
                Explore Universe
              </Link>
              <Link
                to="/login"
                className="px-8 py-4 rounded-full bg-blue-600 text-white font-bold hover:bg-blue-500 transition-all shadow-[0_0_20px_rgba(37,99,235,0.3)] flex items-center gap-2"
              >
                Start Contributing <FiArrowRight size={18} />
              </Link>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Features Grid */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <FeatureCard
            icon={FiStar}
            title="Capsule Evolution"
            desc="Turn contributions into visual energy. Watch your personal capsule evolve as your impact grows across the ecosystem."
            color="text-yellow-400"
          />
          <FeatureCard
            icon={FiGlobe}
            title="Shared Universe"
            desc="See how your efforts connect with the Maysalward community in a beautiful, interactive cosmic map."
            color="text-blue-400"
          />
          <FeatureCard
            icon={FiShield}
            title="Verified Impact"
            desc="Every star represents a verified outcome. Transparent, measurable change powered by the Capsule framework."
            color="text-green-400"
          />
        </div>
      </div>
    </div>
  );
};

const FeatureCard = ({ icon: Icon, title, desc, color }) => (
  <motion.div
    whileHover={{ y: -5 }}
    className="p-8 rounded-2xl bg-slate-900/50 border border-slate-800 backdrop-blur-sm"
  >
    <Icon className={`w-10 h-10 ${color} mb-4`} />
    <h3 className="text-xl font-bold text-white mb-2">{title}</h3>
    <p className="text-slate-400 leading-relaxed">
      {desc}
    </p>
  </motion.div>
);

export default Home;